
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m2.125 15.23.02-.127c.208-1.341 1.083-2.496 2.393-2.85 1.079-.293 2.482-.566 3.962-.566s2.883.273 3.962.565c1.31.355 2.185 1.51 2.393 2.85l.02.127M8.5 8.5a3.542 3.542 0 1 0 0-7.083 3.542 3.542 0 0 0 0 7.083","stroke":"#2a2b2e","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    